import {
  R_ABOUT_US,
  R_SERVICES,
  R_STATISTICAL_PROGRAMMING,
  R_CLINICAL_DATA_MANAGEMENT,
  R_MEDICAL_WRITING,
  R_REGULAR_AFFAIRS,
  R_CAREERS,
  R_VACANCIES,
  R_CONTACT_US,
  R_SAS_TRAININGS,
  R_EXPERTISE,
  R_BLOG,
} from '@/router/routes';

export default [
  {
    label: 'About Us',
    routeName: R_ABOUT_US,
  },
  {
    label: 'Services',
    routeName: R_SERVICES,
    children: [
      {
        label: 'Statistical Programming',
        routeName: R_STATISTICAL_PROGRAMMING,
      },
      {
        label: 'Clinical Data Management',
        routeName: R_CLINICAL_DATA_MANAGEMENT,
      },
      {
        label: 'Medical Writing',
        routeName: R_MEDICAL_WRITING,

      },
      {
        label: 'Regulatory Affairs',
        routeName: R_REGULAR_AFFAIRS,
      },
    ],
  },
  {
    label: 'Expertise',
    routeName: R_EXPERTISE,
  },
  {
    label: 'Careers',
    routeName: R_CAREERS,
    children: [
      {
        label: 'Vacancies',
        routeName: R_VACANCIES,
      },
      {
        label: 'SAS Trainings',
        routeName: R_SAS_TRAININGS,
      },
    ],
  },
  {
    label: 'Blog',
    routeName: R_BLOG,
  },
  {
    label: 'Contact Us',
    routeName: R_CONTACT_US,
  },
];
